import { post } from "@rails/request.js";
import { on } from "@/javascript/lib/delegator";

export const sendUserInteraction = (params = {}) => {
  const { destinationUrl, actionItem, tnId, buttonText, lenderClientId } = params;

  post("/user_interactions/log_action", {
    body: JSON.stringify({
      destination_url: destinationUrl || window.location.href,
      action_item: actionItem,
      tn_id: tnId,
      button_text: buttonText,
      lender_client_id: lenderClientId
    }),
    // keep the associated request alive if the page that initiated
    // it is unloaded before the request is complete
    keepalive: true,
    // ensures that tracking request doesn't slow down the user's
    // current interaction or the loading of the next page
    priority: "low"
  }).catch((error) => {
    console.error("Error logging interaction:", error);
  });
};

export const initTracking = () => {
  on(
    "click",
    ".ui-tracked-link",
    (e) => {
      const currentTarget = e.currentTarget;
      const { lenderClientId } = document.body.dataset;
      const { actionItem, tnId, buttonText } = currentTarget.dataset;

      if (!lenderClientId || !actionItem) {
        return;
      }

      let { destinationUrl } = currentTarget.dataset;

      const formElement = currentTarget.closest("form");
      if (currentTarget.tagName === "BUTTON" && formElement && !destinationUrl) {
        const formAction = formElement.getAttribute("action");
        const { url } = formElement.dataset;
        destinationUrl = url || formAction;
      }

      sendUserInteraction({
        destinationUrl,
        actionItem,
        tnId,
        buttonText,
        lenderClientId
      });
    },
    { capture: true }
  );
};
